'use strict';

module Patersons {

    export class Feed {
        id: string;
        title: string;
        contentSnippet: string;
        content: string;
        feedTitle: string;
        publishedDate: Date;
        publication: string;
        author: string;
        link: string;
        imageLink: string;
        categories: Array<string>;
    }

    export class ResearchFeedService extends BaseService {
        
        getAllPrivateWealthResearch() {
            return this.get("/dataService/api/ResearchArticles/AllPrivateWealthResearch");
        }

        getAllStrategyAndEconomics() {
            return this.get("/dataService/api/ResearchArticles/AllStrategyAndEconomics");
        }

        getFeaturedStrategyAndEconomics() {
            return this.get("/dataService/api/ResearchArticles/FeaturedStrategyAndEconomics");
        }

        getTop3StrategyAndEconomics() {
            return this.get("/dataService/api/ResearchArticles/Top3StrategyAndEconomics");
        }

        getTop3PrivateWealthResearch() {
            return this.get("/dataService/api/ResearchArticles/Top3PrivateWealthResearch");
        }

        getLatestMorningMarket() {
            return this.get("/dataService/api/ResearchArticles/LatestMorningMarket");
        }

        getAllQuantitativeAnalysis() {
            return this.get("/dataService/api/ResearchArticles/AllQuantitativeAnalysis");
        }

        getFeaturedQuantitativeAnalysis() {
            return this.get("/dataService/api/ResearchArticles/FeaturedQuantitativeAnalysis");
        }

        getFeaturedPrivateWealthResearch() {
            return this.get("/dataService/api/ResearchArticles/FeaturedPrivateWealthResearch");
        }

        getTop3QuantitativeAnalysis() {
            return this.get("/dataService/api/ResearchArticles/Top3QuantitativeAnalysis");
        }

        getArticle(articleId: string) {
            return this.get("/dataService/api/ResearchArticles/GetArticle?articleId="+articleId);
        }

        getLatestFeedItemForCategory(feedItems: Feed[], category: string) {
            console.log(feedItems);
            if (feedItems === null || feedItems === undefined) {
                return null;
            }

            let filteredItems = feedItems.filter(item => item.publication.toLowerCase() === category.toLowerCase());

            return this.orderFeedItemsByPublishedDateDescending(filteredItems)[0];
        }

        getLatestFeedItemExcludingCategories(feedItems: Feed[], categories: string[], index: number) {
            if (feedItems === null || feedItems === undefined) {
                return null;
            }

            let filteredItems = feedItems.filter(item => !item.categories.some(c => categories.indexOf(c) != -1));

            if (filteredItems.length <= index) {
                return null;
            }

            return this.orderFeedItemsByPublishedDateDescending(filteredItems)[index];
        }

        orderFeedItemsByPublishedDateDescending(feedItems: Feed[]) {
            if (feedItems === null || feedItems === undefined) {
                return null;
            }

            return feedItems.sort(function (a, b) {
                return moment(b.publishedDate).toDate().getTime() - moment(a.publishedDate).toDate().getTime();
            })
        }
    }
}
